import React, { useEffect, useState } from "react";
import { images } from "../../config/images";
import CommonBreadcrumbs from "../../components/Breadcrumb/Breadcrumb";
import "../Blog/Blog.css";
import "../AboutUs/AboutUs.css";
import { blogdetail, productdetail } from "../../config/services";
import { useLocation, useParams } from "react-router-dom";
import "../PDF/Pdf.css";
import FullpageLoader from "../../Fullscreen/FullScreenLoader";

const Pdf = () => {
  const [blogdetailVar, setBlogDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pdfIframeLoading, setPdfIframeLoading] = useState(true);
  const param = useParams();
  const location = useLocation();
  const blogId = location.state?.blogId;
  const isProductPage = !!param.id;

  const handlePdfIframeLoad = () => setPdfIframeLoading(false);

  useEffect(() => {
    if (isProductPage) {
      handleProductDetail();
    } else {
      handleblogdetail();
    }
  }, []);

  useEffect(() => {
    if (blogdetailVar[0]?.pdf || (blogdetailVar[0]?.image && isPDF(blogdetailVar[0]?.image))) {
      setPdfIframeLoading(true);
    }
  }, [blogdetailVar]);

  const handleProductDetail = async () => {
    const params = {
      id: param.id,
    };
    try {
      setLoading(true);
      const resp = await productdetail({ params });
      if (resp.data.code === 200 || resp.data.code === 201) {
        setBlogDetail(resp.data.responseBody);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("Error in handleProductDetail:", error);
    }
  };

  const handleblogdetail = async () => {
    if (!blogId) return;
    const params = {
      id: blogId,
    };
    try {
      setLoading(true);
      const resp = await blogdetail(params);

      if (resp.data.code === 200 || resp.data.code === 201) {
        setBlogDetail(resp.data.responseBody);
        setLoading(false);
      }
    } catch (error) {
      setLoading(true);
      console.log("Error in handleblogdetails:", error);
    }
  };

  const formatSlug = (slug) =>
    slug?.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  const breadcrumbsData = isProductPage
    ? [
        { label: "Home", url: "/" },
        {
          label: "Division",
          url: "/division",
        },
        {
          label: formatSlug(param.categorySlug),
          url: `/division/${param.categorySlug}`,
        },
        {
          label: blogdetailVar[0]?.title,
        },
      ]
    : [
        { label: "Home", url: "/" },
        {
          label: "Blog",
          url: "/blog",
        },
        {
          label: blogdetailVar[0]?.title,
        },
      ];

  const isPDF = (url) => url?.toLowerCase().endsWith(".pdf");
  return (
    <>
      <div>
        <div className="about-us-container pdf-page-banner">
          <div className="molecule left">
            <img src={images.leftSpirrel} alt="Left Molecule" />
          </div>
          <div className="about-text">
            <h1>{isProductPage ? blogdetailVar[0]?.title || "Product" : "Blog"}</h1>
            <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
          </div>
          <div className="molecule right">
            <img src={images.rightSpirrel} alt="Right Molecule" />
          </div>
        </div>
        <div className="common-sec">
          <div className="pt-5 pb-5 blog-section pdf-title">
            {isProductPage ? (
              <div className="pdf-product-card">
                <div className="pdf-product-header">
                  {loading ? (
                    <div className="shimmer-vision shimmer-title pdf-product-title-shimmer" />
                  ) : (
                    <h1 className="pdf-product-title">{blogdetailVar[0]?.title}</h1>
                  )}
                  {!loading && blogdetailVar[0]?.pdf && (
                    <a
                      href={blogdetailVar[0]?.pdf}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="pdf-open-new-link"
                      aria-label="Open PDF in new tab"
                    >
                      Open in new tab
                    </a>
                  )}
                </div>
                <div className="pdf-product-viewer">
                  {loading ? (
                    <div className="shimmer-blog shimmer-placeholder-image" />
                  ) : blogdetailVar[0]?.pdf ? (
                    <>
                      {pdfIframeLoading && (
                        <div className="pdf-iframe-loading" aria-hidden="true">
                          <span className="pdf-iframe-loading-spinner" />
                          <p>Loading PDF…</p>
                        </div>
                      )}
                      <iframe
                        className="pdf-embed-iframe"
                        src={blogdetailVar[0].pdf}
                        title="PDF Document"
                        width="100%"
                        onLoad={handlePdfIframeLoad}
                      />
                    </>
                  ) : (
                    <div className="pdf-product-empty">No PDF available</div>
                  )}
                </div>
              </div>
            ) : (
              <>
                <div className="blog-detail-card">
                  <div className="blog-detail-header">
                    {loading ? (
                      <div className="shimmer-vision shimmer-title blog-detail-title-shimmer" />
                    ) : (
                      <h1 className="blog-detail-title">{blogdetailVar[0]?.title}</h1>
                    )}
                    {loading ? (
                      <div className="blog-detail-meta">
                        <span className="shimmer-contact-icon" />
                        <span className="shimmer-text" />
                      </div>
                    ) : (
                      <div className="blog-detail-meta">
                        <span className="blog-detail-meta-item">
                          <img src={images.contactImage} alt="" className="blog-detail-meta-icon" />
                          {blogdetailVar[0]?.author_name}
                        </span>
                        <span className="blog-detail-meta-item">
                          <img src={images.calender} alt="" className="blog-detail-meta-icon" />
                          {blogdetailVar[0]?.date &&
                            new Date(blogdetailVar[0]?.date).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "long",
                              year: "numeric",
                            })}
                        </span>
                      </div>
                    )}
                    {loading ? (
                      <div className="shimmer-vision shimmer-title blog-detail-desc-shimmer" />
                    ) : (
                      <p className="blog-detail-description">{blogdetailVar[0]?.description}</p>
                    )}
                  </div>
                  <div className="blog-detail-viewer">
                    {loading ? (
                      <div className="shimmer-blog shimmer-placeholder-image" />
                    ) : isPDF(blogdetailVar[0]?.image) ? (
                      <>
                        {pdfIframeLoading && (
                          <div className="pdf-iframe-loading" aria-hidden="true">
                            <span className="pdf-iframe-loading-spinner" />
                            <p>Loading PDF…</p>
                          </div>
                        )}
                        <iframe
                          className="blog-pdf-embed"
                          src={blogdetailVar[0].image}
                          title="PDF Document"
                          width="100%"
                          onLoad={handlePdfIframeLoad}
                        />
                      </>
                    ) : (
                      <img
                        src={blogdetailVar[0]?.image}
                        className="blog-detail-image"
                        alt="Blog content"
                      />
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Pdf;
